<template>
<div class="chapter">
<div class="inner_page">
<p class="first" id="Copyright">InterVarsity Press<br/>
  P.O. Box 1400<br/>
  Downers Grove, IL 60515-1426<br/><a href="http://www.ivpress.com" target="_blank">www.ivpress.com</a><br/><a href="mailto:email@ivpress.com">email@ivpress.com</a></p>
<p class="first">© Vaughan Roberts 2002</p>
<p class="first">All rights reserved. No part of this book may be reproduced in any form without written permission from InterVarsity Press.</p>
<p class="first">Published in the United States of America by InterVarsity Press, Downers Grove, Illinois, with permission from Universities and Colleges Christian Fellowship.</p>
<p class="first">InterVarsity Press® is the book-publishing division of InterVarsity Christian Fellowship/USA®, a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept. InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at <a href="http://www.intervarsity.org" target="_blank">www.intervarsity.org</a>.</p>
<p class="first">All Scripture quotations, unless otherwise indicated, are taken from the Holy Bible, New International Version®. NIV®.<span class="sgc-1">Copyright ©1973, 1978, 1984 by International Bible Society. Used </span>by permission of Hodder and Stoughton Ltd. All rights reserved. “NIV” is a registered trademark of International Bible Society. UK trademark number 1448790. Distributed in North America by permission of Zondervan Publishing House.</p>
<p class="first sgc-2"><span class="sgc-3">Cover design: David Fassett</span></p>
<p class="first sgc-2"><span class="sgc-3">Images: </span>blue abstract: © kostins/iStockphoto; sea waves: © borchee/iStockphoto; gold: © iSailorr/iStockphoto; Bible pages: © lpkoe/iStockphoto</p>
<p class="first sgc-2">ISBN 978-0-8308-6389-1 (digital)<br/>ISBN 978-0-8308-5364-9 (print)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CopyrightPage.vue?97f277b0